import cookie from 'react-cookie';

const COOKIE_NAME_FLAG = 'dbk-widget-login-remember-me';
const COOKIE_NAME_USER_NAME = 'dbk-widget-login-username';
const COOKIE_MAX_AGE = 400 * 24 * 60 * 60; // 400 days (the limit recommended by the HTTP Working Group Spec and enforced by Chrome)

const shouldRememberUserName = () => {
    return cookie.load(COOKIE_NAME_FLAG) === 'true';
};

const saveUserName = (username, loginConfig) => {
    const { rememberMeGroup } = loginConfig;
    const { isRememberMeEnabled } = rememberMeGroup ?? {};

    if (isRememberMeEnabled && shouldRememberUserName()) {
        cookie.save(COOKIE_NAME_USER_NAME, username, {
            path: '/',
            maxAge: COOKIE_MAX_AGE,
        });
    }
};

const toggleRememberMe = (currentRememberMe) => {
    if (currentRememberMe) {
        cookie.remove(COOKIE_NAME_USER_NAME, { path: '/' });
        cookie.remove(COOKIE_NAME_FLAG, { path: '/' });
    } else {
        cookie.save(COOKIE_NAME_FLAG, 'true', {
            path: '/',
            maxAge: COOKIE_MAX_AGE,
        });
    }
};

const getCurrentUsername = () => {
    return cookie.load(COOKIE_NAME_USER_NAME);
};

export default {};
export {
    saveUserName,
    shouldRememberUserName,
    toggleRememberMe,
    getCurrentUsername,
};
